import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get inventory
export const getInventory = createAsyncThunk("inventory/get non solar Item list", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-inventory`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        console.log({ response })
        console.log("response from inventory", response)
        return response;
    } catch (error) {
        console.error('Error fetching inventory - ', error);
        throw error;
    }
})


